<template>
  <div class="visual_input_wrapper u">
    <div class="grid cross-center">
      <div class="u">
        <input @focus="showOptions=true" class="search_input" :placeholder="searchPlaceholder"/>
      </div>
      <div>
        <!-- <el-button icon="el-icon-close" size="mini"></el-button> -->
      </div>
    </div>
    <div v-show="showOptions" id="visual_search_option_list" v-bar="{preventParentScroll: true, scrollThrottle: 5, draggerThrottle: 5}">
      <div class="vuebar">
        <div class="options_wrapper">
          <span v-for="option in optionList" v-show="option.show" v-if="hideForReport(option.key) && option.hasOwnProperty('is_cp') == false" :key="option.key" class="option" @click="onOptionClick(option)">
            {{ option.name }}
          </span>
          <div class="custom-params" v-if="customParams && customParams.length > 0 && !isSplits">
            <div class="list-title">Доп. параметры</div>
             <el-tag
              type="info"
              v-show="option.show"
              v-for="option in optionList"
              v-if="hideForReport(option.key) && option.hasOwnProperty('is_cp') == true"
              :key="option.key"
              class="cp-tag" @click.native="onOptionClick(option)">
              {{ option.name }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import underscore from "vue-underscore";
import { _ } from "vue-underscore";
Vue.use(underscore);

import Vuex from "vuex";
import { mapGetters } from "vuex";

import Vuebar from "vuebar";
Vue.use(Vuebar);

export default {
  name: "InputSearch",
  props: [
    "removeOnSelect",
    "optionList",
    "termList",
    "searchPlaceholder",
    "isReport",
    "isSplits",
    "searchOpt"
  ],
  data() {
    return {
      value: "",
      showOptions: false,
      inputSearchValue: "",
      selectedOptions: [],
      searchFields: this.$store.state.search.searchFields
    };
  },
  methods: {
    onOptionClick(option) {
      this.$emit("onOptionClick", option);
      this.showOptions = false;
    },
    hideOptions() {
      if (this.showOptions) {
        this.showOptions = false;
      }
    },
    handleOutsideClick($event) {
      var flag = true;
      var element = $event.target.parentElement;
      if (element != null) {
        while (flag) {
          if (element.classList.contains("visual-search")) {
            flag = false;
          } else if (element.nodeName == "BODY") {
            flag = false;
            this.hideOptions();
          }
          element = element.parentElement;
        }
      }
    },
    hideForReport(name) {
      if (name == "terminals" && this.termList.length < 2) return false;
      if (this.isReport) {
        if (
          name == "merchant_orders" ||
          name == "map_orders" ||
          name == "amount_range" ||
          name == "rrns" ||
          name == "split_terminals"
        ) {
          return false;
        } else {
          return true;
        }
      } else if (this.isSplits) {
        if (
          name == "processings" ||
          name == "merchants" ||
          name == "terminals" ||
          name == "split_terminals" ||
          name == "merchant_orders" ||
          name == "map_orders" ||
          name == "amount_range" ||
          name == "date_range"
        )
          return true;
        else return false;
      } else {
        if (name == "split_terminals") return false;
      }
      return true;
    }
  },
  computed: {
    ...mapGetters(["customParams"])
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick, false);
  },
  destroyed() {
    document.removeEventListener("click", this.handleOutsideClick, false);
  }
};
</script>

<style lang="css" >
::-webkit-input-placeholder {
  color: #e7e7e7;
}
::-moz-placeholder {
  color: #e7e7e7;
} /* Firefox 19+ */
:-moz-placeholder {
  color: #e7e7e7;
} /* Firefox 18- */
:-ms-input-placeholder {
  color: #e7e7e7;
}
</style>
